<template>
  <div style="margin: 0 24px 12px;">
    <el-form ref="formRef" :model="userForm" label-width="90px" label-position="right">
      <el-form-item label="" v-if="idx  <= -1">
        <el-input type="textarea" :rows="4" v-model="pasteInfo" placeholder="粘贴用户信息，自动识别
例：
主人贵姓：
主人手机：" style="width: 34em" @input="pasteChange"/>
      </el-form-item>
      <el-form-item label="贵姓：">
        <el-input v-model="userForm.name" placeholder="请输入贵姓" style="width: 34em" />
        <p style="color: red; font-size: 12px;">*信息将对客户可见，请谨慎填写</p>
      </el-form-item>
      <el-form-item label="手机：">
        <el-input v-model="userForm.phone" :maxlength="11" placeholder="请输入手机号" style="width: 34em"/>
      </el-form-item>

      <el-form-item label="性别：">
        <el-radio-group v-model="sex">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
          <el-radio :label="0">未知</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="门店：">
        <p v-if="!editable || userForm.type == 1" style="display: flex; justify-content: space-between; width: 34em">
          <span>{{userForm.shopName}}</span>
          <el-button v-if="userForm.type != 1" type="text" @click="editable = true">编辑</el-button>
        </p>
        <el-select v-else v-model="shopId" placeholder="请选择" style="width: 34em">
          <el-option v-for="item in shopIdArr" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="微信绑定：" v-if="this.idx > -1">
        <div style="display: flex; justify-content: space-between; width: 34em">
          <p>{{userForm.userAppletId > 0?'已绑定':'未绑定'}}</p>
          <el-button v-if="(operateState & 8) == 8 && userForm.userAppletId > 0" type="success" @click="unbindWechat">解除微信绑定</el-button>
        </div>
      </el-form-item>
      <el-form-item label="描述：">
        <el-input v-model="userDesc" type="textarea" :rows="2" placeholder="请简单描述客户信息" style="width: 34em" />
      </el-form-item>

      <el-form-item label="图片：" v-if="idx > -1">
        <div>
          <el-space>
            <div class="img-box" v-for="(item, index) in imgArray.slice(0, 4)" :key="item.id">
              <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div class="add" v-if="imgArray.length > 0" @click="userImgList()">
              <span>全部图片</span>
            </div>
          </el-space>
          <div>
            <el-button @click="fileUpdate">+ 上传图片</el-button>
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
          </div>
        </div>
      </el-form-item>

      <el-form-item label="宠物：" v-if="idx > -1">
<!--        <el-button :style="{marginTop: petList.length>0?'8px': ''}" @click="addOrUpdatePet(-1)">+ 添加宠物</el-button>-->
        <el-button @click="addPet(-1)">+ 添加宠物</el-button>
        <div style="width: 31em; padding: 1em 1.5em; background-color: #f6f6f6; border-radius: 4px;margin-top: 12px;" v-if="petList.length > 0">
          <div v-for="(item, index) of petList" :key="item.id" style="display: flex; justify-content: space-between; line-height: 2">
            <div>
              <p>{{item.petBreedName}}/{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（ {{item.name}} ）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</p>
              <p v-if="item.exemptionDesc" style="color: red; font-size: 12px; margin-top: -6px;">*{{item.exemptionDesc}}</p>
            </div>
            <div>
              <el-button size="small" type="text" @click="delPet(index, item)">删除</el-button>
              <el-button size="small" type="text" @click="updatePet(index, item)">编辑</el-button>
            </div>
          </div>

        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addOrUpdateCustomer, getPet, getUserInfo, updatePetDel, unbindApplet} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import Drawer from "@/assets/js/drawer"
import AddOrUpdatePet from "@/views/user/components/AddOrUpdatePet";
import UserImgUpload from "@/components/imgList/UserImgUpload";
import UserImgList from "@/components/imgList/UserImgList";
import {positiveIntReg} from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
      sex: this.value.ids>-1?this.value.userForm.sex:'',
      idx: this.value.ids,
      shopIdArr: [],
      shopId: this.value.userForm.shopId?this.value.userForm.shopId:'',
      pasteInfo: '',
      petList: this.value.userForm.petList?this.value.userForm.petList: [],
      // visibleShopList: JSON.parse(sessionStorage.getItem('visibleShopList')),
      ownShopList: JSON.parse(sessionStorage.getItem('ownShopList')),
      editable: false,

      userDesc: this.value.userForm.userPerfect?this.value.userForm.userPerfect.userDesc:'',

      imgArray: this.value.userForm.userImgList?this.value.userForm.userImgList:[],

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

    }
  },
  methods: {


    //更改或添加
    fileUpdate() {
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        let imgArr = []
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          // this.imgArray.push(obj);
          imgArr.push(obj)
        }
        this.$refs.file.setAttribute('type', 'text')
        Dialog.open({
          title: '上传图片',
          component: UserImgUpload,
          data: {
            imgArray: imgArr,
            id: this.userForm.id,
            width: '800px',
            from: 1
          },
          confirm: (result) => {

            this.getUserInfoImg()
          }
        })
      }
    },

    getUserInfoImg() {
      getFormData(getUserInfo, {id: this.userForm.id}).then(data => {
        this.imgArray = data.data.userImgList
      })
    },

    userImgList() {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: this.imgArray,
          id: this.userForm.id,
          width: 908,
          from: 1
        },
        confirm: (result) => {
          this.getUserInfoImg()
        }
      })
    },


    pasteChange(val) {
      let arr = val.split('\n');
      arr.map(item => {
        let string = item.replace(/\s*/g, '').replace(':', '：')
        if(string.indexOf('主人手机') > -1) {
          let arr_p = string.split('：')
          this.userForm.phone = arr_p[1]
        }
        if(string.indexOf('主人贵姓') > -1) {
          let arr_n = string.split('：')
          this.userForm.name = arr_n[1]
        }
      })
    },


    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.userForm.phone) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '手机号不能为空',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.sex)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择性别',
          type: 'warning'
        });
        return false
      }
      // if(this.idx == -2 && this.petList.length == 0) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请添加宠物',
      //     type: 'warning'
      //   });
      //   return false
      // }
      if(!this.shopId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择门店',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.userForm.id:0;
      param['phone'] = this.userForm.phone;
      param['name'] = this.userForm.name;
      param['userDesc'] = this.userDesc;
      param['sex'] = this.sex;
      param['shopId'] = this.shopId;
      param['projectId'] = this.projectId;
      if(this.idx <= -1 && this.petList.length > 0) {
        let petArr = []
        this.petList.map(item => {
          petArr.push(item.id)
        })
        param['petIdArr'] = petArr
      }
      postFormData(addOrUpdateCustomer, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', data.data)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


    addPet(idx, row) {
      // if(!this.editable) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '当前角色没有该门店的编辑权限',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let _title = '';
      let petForm = {}
      _title = '添加宠物'
      Drawer.open({
        title: _title,
        component: AddOrUpdatePet,
        data: {
          petForm: petForm,
          ids: idx,
          userId: this.idx > -1?this.userForm.id:0,
          width: 600
        },
        confirm: (result) => {
          this.getPetInfo(idx, result)
        }
      })
    },

    getPetInfo(idx, result) {
      getFormData(getPet, {id: result}).then(data => {
        if(idx > -1) {
          this.petList[idx] = data.data
        }else {
          this.petList.push(data.data)
        }
      })
    },

    updatePet(idx, row) {
      // if(!this.editable) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '当前角色没有该门店的编辑权限',
      //     type: 'warning'
      //   });
      //   return false
      // }


      getFormData(getPet, {id: row.id}).then(data => {
        let _title = '';
        let petForm = {}
        _title = '编辑宠物'
        petForm = data.data

        Drawer.open({
          title: _title,
          component: AddOrUpdatePet,
          data: {
            petForm: petForm,
            ids: idx,
            userId: this.idx > -1?this.userForm.id:0,
            width: 600
          },
          confirm: (result) => {
            this.getPetInfo(idx, result)
          }
        })

      })


    },

    delPet(idx, row) {
      // if(!this.editable) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '当前角色没有该门店的编辑权限',
      //     type: 'warning'
      //   });
      //   return false
      // }
      this.$confirm('确认删除宠物【' + row.name + '】？').then(() => {
        let param = {}
        param['id'] = row.id;
        postFormData(updatePetDel, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.petList.splice(idx, 1)
          } else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      })
    },

    unbindWechat() {
      this.$confirm('确定解除主人【'+ this.userForm.name +'】的微信绑定关系吗？').then(()=> {
        postFormData(unbindApplet, {id: this.userForm.id}).then(data => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm')
          } else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      })
    }


  },
  mounted() {
    this.shopIdArr = this.ownShopList.filter(item => item.isEdit == 1)
    if(this.idx > -1) {
      this.ownShopList.map(item => {
        if(item.id == this.shopId && item.isEdit == 1) {
          this.editable = true
        }
      })
    }else {
      this.editable = true
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ccc;
  font-size: 12px;
  cursor: pointer;
  /*float: left;*/
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

</style>
